import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import store from "@src/reducers/store";
import {
  TreeProps,
  updateEditStructurePageTransferData,
} from "@src/reducers/your-reducer";

export const writeReduxStateForMachineStructureWithLatestSavedStructure =
  () => {
    const originalMachineStructureAfterCallingEndpointOrSaving =
      store.getState().yourSlice.editStructurePageTransferData;

    const machineStructureNodesetInstance = getMachineStructureNodeset();

    // getting the overwritten root node to then create
    // a serializable root node to be written in redux
    const machineStructureRootNode =
      machineStructureNodesetInstance.getRootNode();

    const rootNodeNotOurNode =
      machineStructureRootNode.getSerializableRootNodeFromOurNode();

    const machineStructure: TreeProps = {
      ...originalMachineStructureAfterCallingEndpointOrSaving,
      nodeset: {
        ...originalMachineStructureAfterCallingEndpointOrSaving.nodeset,
        root_node: rootNodeNotOurNode,
      },
    };

    store.dispatch(updateEditStructurePageTransferData(machineStructure));
  };
